import React, { useState } from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";
import { getProgress } from "../../../../ProgressBarView/util/getProgress";
import { Bar } from "../components/Bar";

import { BreakpointIcons } from "./BreakpointIcons";
import { BreakpointLabels } from "./BreakpointLabels";

export const ProgressBar = () => {
  const [margins, setMargins] = useState({ left: 0, right: 0 });
  const { state, config } = useProgressBarContext();

  const onMarginChange = (type: "left" | "right", margin: number) => {
    if (type === "left") {
      setMargins((margins) => ({ ...margins, left: margin }));
    } else {
      setMargins((margins) => ({ ...margins, right: margin }));
    }
  };

  const getWeight = (index: number) => {
    if (state.breakpoints.length == 1) {
      return 1;
    } else {
      if (index === 0) {
        return 0;
      }
      return 1 / (state.breakpoints.length - 1);
    }
  };
  const progress = getProgress(state, getWeight);

  return (
    <Container className={"ig-content"} margins={margins}>
      {config.desktop.widget.styles.layout.swapTextPositions ? (
        <>
          <BreakpointIcons>
            <StyledBar progress={progress} />
          </BreakpointIcons>
          {config.desktop.widget.styles.breakpoint.hideText ? null : (
            <BreakpointLabels onMarginChange={onMarginChange} />
          )}
        </>
      ) : (
        <>
          {config.desktop.widget.styles.breakpoint.hideText ? null : (
            <BreakpointLabels onMarginChange={onMarginChange} />
          )}
          <BreakpointIcons>
            <StyledBar progress={progress} />
          </BreakpointIcons>
        </>
      )}
    </Container>
  );
};

const Container = styled("div")(
  ({ margins }: { margins: { left: number; right: number } }) => ({
    marginLeft: margins.left,
    marginRight: margins.right,
    display: "flex",
    flexDirection: "column",
    rowGap: 10,
  })
);

const StyledBar = styled(Bar)({
  flex: 1,
});
